import { passCodes } from '../passCodes';
import cipher22Image from '../../../../assets/images/games/zdar-escape-game/ciphers/22/hint2-transparent.webp';
import track22 from '../../../../assets/audio/tracks/track22.mp3';

const hints = [
    {
        text: 'Určitě už jste si všimli, že na některých písmenech jsou šipky, správně, zaměřte se právě na ně. No a pak to už znáte, vždycky se řadí od největšího po nejmenší.',
    },
    {
        text: 'Kódem je: dál rovně',
        solution: true,
    },
];
export const step22pipe = {
    id: 21,
    title: '9. stanoviště',
    taskText: `
        <p>
            Ty jo, tak to nám moc neřeklo, ale ty čárky na tom asi něco znamenají, asi nějakou zprávu. Co by to asi mohlo být?  
        </p>
    `,
    catImage: 8,
    audio: track22,
    snowAudio: track22,
    cipher: {
        label: 'Úkol',
        images: [cipher22Image],
        text: 'Pilíře odpovídají vždy jednomu písmenu abecedy a to i s háčky. Podívejte se pozorně, některé čárky jsou odlišné, není to náhoda. Vyjde vám směr, kudy máte jít dál.',
    },
    codeInputText: 'Zadejte kód',
    codeInputPassCodeRegexp: passCodes[14],
    hints: hints,
    snowHints: hints,
};
